// extracted by mini-css-extract-plugin
export default {"root":"index_root__QToja","footerContainer":"index_footerContainer__LPiW4","title":"index_title__yHyVw"};